export class FilterObject {
    // filterData  - main settings for filtering. Upon changes, the results are put to router query
    // filterProps - settings to be saved in the router query as well, but without updating the results
    constructor(router, route, filterData, filterProps) {
        this.router = router;
        this.route = route;
        this.filterData = {};
        this.filterProps = {};
        this.initData = filterData;
        this.initProps = filterProps;
        this._init(filterData, this.filterData);
        this._init(filterProps, this.filterProps);
    }

    _init(dataSet, obj, initRoute = true) {
        for (let data of dataSet) {
            let key = data.key;
            let value = data.default;

            if (initRoute && this.route.query && this.route.query.hasOwnProperty(key)) {
                if (typeof(value) === 'boolean') {
                    value = 'true' === this.route.query[key];
                }
                else if (Number.isInteger(value)) {
                    value = parseInt(this.route.query[key]);
                }
                else {
                    value = this.route.query[key];
                }
            }

            obj[key] = value;
        }
    }

    reset() {
        this._init(this.initData, this.filterData, false);
        this._init(this.initProps, this.filterProps, false);
        this.updateQuery();
    }

    updateQuery() {
        // save vertical scroll position to avoid jumping to top
        // TODO is window.scrollY generic for most browsers?
        this.router.manuallySavedPosition = { x: 0, y: window.scrollY };
        let queryData = {};

        for (let key in this.filterData) {
            if (this.filterData[key] !== '' && this.filterData[key] !== false) {
                queryData[key] = this.filterData[key];
            }
        }

        for (let key in this.filterProps) {
            if (this.filterProps[key] !== '' && this.filterProps[key] !== false) {
                queryData[key] = this.filterProps[key];
            }
        }

        this.router.push({ 
            query: queryData
        }).catch(() => { });
    }
}